import { IContactTag } from "../generated/Api";

export enum ContactStatus {
  CONFIRMED = "CONFIRMED", // When the user confirms his email via email
  NOT_CONFIRMED = "NOT_CONFIRMED", // Initial state of users
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION", // When the user gets sent a confirmation email
  UNSUBSCRIBED = "UNSUBSCRIBED", // When the contact unsubs from the link on the email
  ADMIN_UNSUBSCRIBED = "ADMIN_UNSUBSCRIBED", // When the owner unsubs a contact
  SPAM = "SPAM", // When the contact marks the email as SPAM
  BLOCKED = "BLOCKED", // When the contact gets blocked by user defined rules
  BOT_FILLED = "BOT_FILLED", // When the hidden input on a form is filled, so it must be a bot
  SUPRESSED = "SUPRESSED", // When the contact gets suppressed by the system rules
}

export const allStatus: { [key in ContactStatus]: string } = {
  [ContactStatus.CONFIRMED]: "Confirmed",
  [ContactStatus.NOT_CONFIRMED]: "Not confirmed",
  [ContactStatus.PENDING_CONFIRMATION]: "Pending confirmation",
  [ContactStatus.UNSUBSCRIBED]: "Unsubscribed",
  [ContactStatus.ADMIN_UNSUBSCRIBED]: "Admin unsubscribed",
  [ContactStatus.SPAM]: "Spam",
  [ContactStatus.BLOCKED]: "Blocked",
  [ContactStatus.BOT_FILLED]: "Bot filled",
  [ContactStatus.SUPRESSED]: "Supressed",
};

export const CONTACT_STATUS_TO_RECEIVE_CONFIRMATION = [
  ContactStatus.PENDING_CONFIRMATION,
  ContactStatus.NOT_CONFIRMED,
  ContactStatus.BOT_FILLED,
];

export interface IContact {
  _id: string;
  profile_pic?: string;
  userUid: string;
  name: string;
  email: string;
  labels: string[];
  tags: IContactTag[];
  avatar: string;
  status: ContactStatus;
  createdAt: Date;
  phone?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  deviceIds?: string[];
  lastIp?: string;
  deviceInfo?: {
    ip: string;
    deviceId: string;
  };
  customFields?: {
    [key: string]: string;
  };

  billingStreet1?: string;
  billingStreet2?: string;
  billingCity?: string;
  billingCountry?: string;
  billingState?: string;
  billingPostalCode?: string;
  billingPhoneCountryCode?: string;
  billingPhone?: string;
  billingFullAddress?: string;
  billingPlaceId?: string;
  billingStreetNumber?: string;
  favoriteCustomFields?: string[];
  shippingStreet1?: string;
  shippingStreet2?: string;
  shippingCity?: string;
  shippingCountry?: string;
  shippingState?: string;
  shippingPostalCode?: string;
  shippingPhoneCountryCode?: string;
  shippingPhone?: string;
  shippingFullAddress?: string;
  shippingPlaceId?: string;
  shippingStreetNumber?: string;
  testimonial?: string;
}
